

class MvCarouselProgress {
  private carouselProgressEl:HTMLElement;
  private progressBarEl:HTMLElement;
  private mvCarouselCenterEl:HTMLElement;
  private numSlides:number;
  private frameNum:number = 0;
  private frameDuration:number = 100;
  private autoplayDuration:number;
  private frameTimeoutId;

  constructor(_autoplayDuration:number) {
    this.carouselProgressEl = document.querySelector('.mv__carousel-progress');
    this.progressBarEl = this.carouselProgressEl.querySelector('.mv__carousel-progress-bar');
    this.mvCarouselCenterEl = document.querySelector('#mvCarouselCenter');
    this.autoplayDuration = _autoplayDuration;

    this.init();

    //this.startCountFrame();
  }

  init() {
    //this.numSlides = this.mvCarouselCenterEl.querySelectorAll('.swiper-slide').length;
    //this.progressBarEl.style.width = `${100 / this.numSlides}%`;
  }

  update(index:number) {
    //let per = index * (100 / this.numSlides);
    //this.progressBarEl.style.left = `${per}%`;
  }
  transitionStart() {
    this.progressBarEl.style.transitionDuration = '0s';
    this.progressBarEl.style.transform = 'scaleX(0)';
  }

  transitionEnd() {
    this.progressBarEl.style.transitionDuration = this.autoplayDuration + 'ms';
    this.progressBarEl.style.transform = 'scaleX(1.02)';
  }
  /*
  updateBar(){
    let pp = ((this.frameNum * this.frameDuration) / this.slideDuration) * 100;
    this.progressBarEl.style.width = `${pp}%`;
  }

  startCountFrame() {
    this.countFrame();
  }

  pauseCountFrame() {
    clearTimeout(this.frameTimeoutId);
  }

  stopCountFrame() {
    clearTimeout(this.frameTimeoutId);
    this.frameNum = 0;
    this.updateBar();
  }

  async countFrame() {
    await new Promise(resolve => this.frameTimeoutId = setTimeout(resolve, this.frameDuration))
    this.frameNum++;
    console.log(this.frameNum);
    this.updateBar();

    if((this.frameNum * this.frameDuration) >= this.slideDuration){
      //this.stopCountFrame();

      const event = new CustomEvent('progressComplete');
      window.dispatchEvent(event);

    } else {
      this.countFrame();
    }
  }
  */
}

export default MvCarouselProgress;

